
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor("Matrix.Data.TestResultTable")
    @Serenity.Decorators.element("<div/>")
    export class TestResultTable extends Serenity.DataGrid<any, any> {

        private autoSize: Serenity.AutoColumnWidthMixin;

        constructor(container) {

            super(container)
            this.slickContainer.css('min-height', '350px');
            this.autoSize = new Serenity.AutoColumnWidthMixin({
                grid: this
            });
       
            new Serenity.HeaderFiltersMixin({
                grid: this,
                filterByText: true
            });
        }

        protected getDefaultSortBy() {
            return ["batch_code"];
        }
        protected getIdProperty() {
            return "__id";
        }

        public getColumns() {
            return [];
        }

        private _xmlData: string;

        protected getGridCanLoad() {
            return false;
        }

        protected usePager() {
            return false;
        }

        get xmlData(): string {
            return this._xmlData;
        }

        editColumns: (columns: Slick.Column[]) => Slick.Column[];

        set xmlData(value: string) {
            value = Q.trimToNull(value);

            if (!value) {
                this.view.setItems([], true);
                this.slickGrid.setColumns([]);
                return;
            }

            var colByName: Q.Dictionary<Slick.Column> = {};
            var cols: Slick.Column[] = [];

            var items: any[] = [];
            var doc = new DOMParser().parseFromString(value, "text/xml");
            var rows = doc.firstChild.childNodes;
            var nextId: number = 0;
            for (var i = 0; i < rows.length; i++) {
                var row = rows[i];
                var cn = row.childNodes;
                var item: any = {
                    __id: ++nextId
                };
                for (var j = 0; j < cn.length; j++) {
                    var node = cn[j];
                    var name = node.nodeName;
                    item[name] = node.textContent;
                    if (!colByName[name]) {
                        var col = <Slick.Column>{
                            field: name,
                            id: name,
                            name: titleize(name),
                            sortable: true
                        };

                        cols.push(col);
                        colByName[name] = col;
                    }
                }
                items.push(item);
            }

            if (this.editColumns) {
                cols = this.editColumns(cols);
            }

            this.view.setItems(items, true);
            this.slickGrid.setColumns(cols);
    
            this.autoSize.autoSizeAllColumns();
            this.updateInterface();
        }

        protected getButtons() {
            return [
                {
                    hint: 'Excel',
                    title: 'Export',
                    cssClass: 'export-xlsx-button',
                    icon: 'fa-file-excel-o',
                    disabled: () => !this.slickGrid?.getColumns().length ||
                        !this.getItems().length,
                    onClick: () => {

                        if (!this.slickGrid.getColumns().length ||
                            !this.getItems().length) {
                            Q.notifyWarning('There is no data to export!');
                            return;
                        }

                        Q.postToService({
                            url: Q.resolveUrl('~/Report/TableExcelExport'),
                            request: <TableExcelExportRequest>{
                                Columns: this.slickGrid.getColumns().map(src => <TableExcelExportColumn>{
                                    Name: src.id || src.field,
                                    Title: src.name || '_'
                                }),
                                Data: gridTableDataToExcel(this.getItems(), this.slickGrid.getColumns())
                            },
                            target: '_blank'
                        });
                    }
                }
            ];
        }      

        getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected getSlickOptions(): Slick.GridOptions {
            var opt: Slick.GridOptions = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            return opt;
        }
    }

    export function gridTableDataToExcel(entities: any[], srcColumns: Slick.Column[]) {
        var el = document.createElement('span');
        var row = 0;
        return entities.map(function (item) {
            var dst = {};
            for (var cell = 0; cell < srcColumns.length; cell++) {
                var src = srcColumns[cell];
                var fld = src.field || '';
                var html = void 0;
                if (src.formatter) {
                    html = src.formatter(row, cell, item[fld], src, item);
                }
                else if (src.format) {
                    html = src.format({ row: row, cell: cell, item: item, value: item[fld] });
                }
                else {
                    dst[fld] = item[fld];
                    continue;
                }
                if (!html || (html.indexOf('<') < 0 && html.indexOf('&') < 0))
                    dst[fld] = html;
                else {
                    el.innerHTML = html;
                    if (el.children.length == 1 &&
                        $(el.children[0]).is(":input")) {
                        dst[fld] = $(el.children[0]).val();
                    }
                    else if (el.children.length == 1 &&
                        $(el.children).is('.check-box')) {
                        dst[fld] = $(el.children).hasClass("checked") ? "X" : "";
                    }
                    else
                        dst[fld] = el.textContent || '';
                }
            }
            row++;
            return dst;
        });
    }
}